import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const ConfirmationModal = React.memo(
  ({ isOpen, toggle, onConfirm, title, message, confirmText, cancelText, confirmColor, loading }) => {
    return (
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>{title || "Confirmare"}</ModalHeader>
        <ModalBody>{message}</ModalBody>
        <ModalFooter>
          <Button color={confirmColor || "danger"} onClick={onConfirm} disabled={loading}>
            {confirmText || "Da, sterge"}
          </Button>
          <Button color="secondary" onClick={toggle} disabled={loading}>
            {cancelText || "Anuleaza"}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
);

export default ConfirmationModal;
